"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GoogleRecaptchaV3Validator = exports.GLOBAL_HIDE_CAPTCHA_BADGE_CLASSNAME = exports.GoogleRecaptchaV3ValidatorInner = exports.OverrideExecuteRecaptchaContextForTests = void 0;
var tslib_1 = require("tslib");
var React = require("react");
var react_google_recaptcha_v3_1 = require("react-google-recaptcha-v3");
exports.OverrideExecuteRecaptchaContextForTests = React.createContext({ executeRecaptcha: null });
exports.GoogleRecaptchaV3ValidatorInner = function (props) {
    // In tests, we can use `OverrideExecuteRecaptchaContextForTests` to override the execute function
    // since google's script is not available in tests
    var overriddenExecuteRecaptchaInTests = React.useContext(exports.OverrideExecuteRecaptchaContextForTests).executeRecaptcha;
    // In production, google exposes a function to issue a re-captcha verification
    // this function will return a token, which we can then send to our server
    // our server can then check the authenticity of the current user, by sending this token to google
    var realExecuteRecaptchaFunction = react_google_recaptcha_v3_1.useGoogleReCaptcha().executeRecaptcha;
    var executeRecaptcha = overriddenExecuteRecaptchaInTests || realExecuteRecaptchaFunction;
    React.useEffect(function () {
        props.registerExecuteRecaptcha(executeRecaptcha);
    }, [executeRecaptcha]);
    return null;
};
exports.GLOBAL_HIDE_CAPTCHA_BADGE_CLASSNAME = 'contact-form-hide-captcha-v3-badge';
// This component manages the embedding of google's re-captcha v3 script
exports.GoogleRecaptchaV3Validator = function (props) {
    // Recaptcha V3 no longer renders the badge inside the parent component, it is rendered on the `body` instead
    // in order to hide it, we add a special classname + a rule inside `_submit-ticket.scss` that hides it
    React.useEffect(function () {
        document.body.classList.add(exports.GLOBAL_HIDE_CAPTCHA_BADGE_CLASSNAME);
        return function () {
            document.body.classList.remove(exports.GLOBAL_HIDE_CAPTCHA_BADGE_CLASSNAME);
        };
    }, []);
    return (
    // The provider takes our re-captcha account key and embeds the actual script inside the page header
    // It populates a context with the correct `executeCaptcha` function
    React.createElement(react_google_recaptcha_v3_1.GoogleReCaptchaProvider, { reCaptchaKey: props.recaptchaKey },
        React.createElement(exports.GoogleRecaptchaV3ValidatorInner, tslib_1.__assign({}, props))));
};
//# sourceMappingURL=google-recaptcha-v3.comp.js.map